import { cn } from "@/lib/utils";

interface ListRowSkeletonProps {
  rowCount?: number;
  /** Avatar diameter class; defaults to the 44px list standard. */
  avatarClassName?: string;
  /** Render a trailing pill (e.g. where an action button will appear). */
  trailingPill?: boolean;
  className?: string;
}

/**
 * Zero-shift skeleton for avatar+text list rows (comments, likes, people).
 * Mirrors SearchableUserListSkeleton rows: 44px avatar, two line-height bars,
 * optional trailing pill. Row height matches the real rows (py-3 + h-11).
 */
export function ListRowSkeleton({
  rowCount = 4,
  avatarClassName = "h-11 w-11",
  trailingPill = false,
  className,
}: ListRowSkeletonProps) {
  const keys = Array.from(
    { length: rowCount },
    (_, index) => `list-row-skeleton-${index}`,
  );

  return (
    <div className={className}>
      {keys.map((key) => (
        <div
          key={key}
          className="flex animate-pulse items-center gap-3 px-3 py-3"
        >
          <div
            className={cn(
              "shrink-0 rounded-[30%] bg-surface-alt",
              avatarClassName,
            )}
          />
          <div className="min-w-0 flex-1 space-y-2">
            <div className="h-4 w-32 rounded bg-surface-alt" />
            <div className="h-3 w-24 rounded bg-surface-alt" />
          </div>
          {/* Matches the measured ConnectButton at `size="sm"` (80x32), the
              action these rows actually resolve to. */}
          {trailingPill ? (
            <div className="h-8 w-20 shrink-0 rounded-full bg-surface-alt" />
          ) : null}
        </div>
      ))}
    </div>
  );
}
